import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-add-edit-organization-modal',
    templateUrl: './add-edit-organization-modal.component.html',
    styleUrls: ['./add-edit-organization-modal.component.scss'],
    standalone: false
})
export class AddEditOrganizationModalComponent implements OnInit {

  @Output() submit: EventEmitter<string> = new EventEmitter();
  submitted = false;
  addNewOrganizationForm: UntypedFormGroup;

  constructor( 
    public activeModal: NgbActiveModal,
    private formBuilder: UntypedFormBuilder) { }

  ngOnInit(): void {

    this.addNewOrganizationForm = this.formBuilder.group({
      name: ['', [Validators.required]]
    });
  }

  
  /**
   * Get reactive form
   */

  get newOrganizationForm() { return this.addNewOrganizationForm.controls; }

  /**
   * Modal submit
   */

  onSubmit() {
    this.submitted = true;
    if (this.addNewOrganizationForm.valid) {
      this.submit.emit(this.addNewOrganizationForm.value.name);
      this.activeModal.close();
    }
  }

  /**
   * Close modal
   */

  onClose() {
    this.activeModal.close();
  }

  
  
}
